import config from "../../helper/config";
import APIHandler from "../../handlers/APIHandler";

export const searchService = {
    getAllMetaDataForQuestionSummary: getAllMetaDataForQuestionSummary,
    getAllQuestionSummaryMonthlyByLanguageSubject: getAllQuestionSummaryMonthlyByLanguageSubject,
    getAllQuestionStats: getAllQuestionStats,
};

async function getAllQuestionSummaryMonthlyByLanguageSubject(
    limit,
    offset,
    sort_column,
    sort_direction,
    search_term,
    selectedGrades,
    selectedSubjects,
    selectedLanguages,
    selectedCreators,
    selectedStartDate,
    selectedEndDate,
    selectedMonth,
    selectedWeek,
) {
    const requestOptions = {
            method: 'GET',
            headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        };
    return await fetch(`${config.oat_api_url}/questions/search/monthly/filter/getAll?limit=${limit}&offset=${offset}&sort_column=${sort_column}&sort_direction=${sort_direction}&search_term=${search_term}&selectedGrades=${selectedGrades}&selectedSubjects=${selectedSubjects}&selectedLanguages=${selectedLanguages}&selectedCreators=${selectedCreators}&selectedStartDate=${selectedStartDate}&selectedEndDate=${selectedEndDate}&selectedMonth=${selectedMonth}&selectedWeek=${selectedWeek}`, requestOptions).then(APIHandler.handleResponse);
}

async function getAllMetaDataForQuestionSummary() {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    return await fetch(`${config.oat_api_url}/questions/search/get-all-meta-data/`, requestOptions).then(APIHandler.handleResponse);
}

async function getAllQuestionStats(
    node_id, 
    user_id, 
    user_table_id,
    user_type,
    language,
    grade,
    subject,
    creator,
    start,
    end
) {
    
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    return await fetch(`${config.oat_api_url}/questions/search/get-statistics/${node_id}/${user_id}/${user_table_id}?user_type=${user_type}&language=${language}&grade=${grade}&subject=${subject}&creator=${creator}&start=${start}&end=${end}`, requestOptions).then(APIHandler.handleResponse);
}
